import React, {
  Fragment,
  useCallback,
  useContext,
  useMemo,
  useRef,
  useState,
} from "react";
import { Fade, Zoom } from "react-awesome-reveal";
import { Helmet } from "react-helmet-async";
import { Link, useLocation, useNavigate } from "react-router-dom";
// import { BookingForm } from "../components/BookingForm";
// import { BookingFormGroup } from "../components/cruiseBooking/BookingFormGroup";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";

import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation, Autoplay } from "swiper/modules";
// import "swiper/swiper-bundle.min.css";
import { DateRangePicker, SelectPicker } from "rsuite";
import "rsuite/dist/rsuite.min.css";
import { format } from "date-fns";
import Rating from "@mui/material/Rating";
import Box from "@mui/material/Box";
import StarIcon from "@mui/icons-material/Star";
import {
  Alert,
  Button,
  colors,
  Slider,
  Snackbar,
  Tooltip,
  useMediaQuery,
} from "@mui/material";
// import useGoogleMapsScript from "../components/useGoogleMapsScript";
import { useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowsUpDownLeftRight,
  faBed,
  faEnvelope,
  faLocationDot,
  faMapLocationDot,
  faMaximize,
  faMinus,
  faPhone,
  faSquarePlus,
  faUsersViewfinder,
} from "@fortawesome/free-solid-svg-icons";

import { useDispatch, useSelector } from "react-redux";
import Loader from "../../Loader";

import { fetchCheckOut } from "../../data/groupBooking/checkOutSlice";
import { fetchConfirmationBooking } from "../../data/groupBooking/confirmationBookingSlice";
import { BrandColorContext } from "../../App";
import { useTranslation } from "react-i18next";

const Checkout = () => {
  const { t } = useTranslation();
  const isMobile = useMediaQuery("(max-width:767px)");
  const isTablet = useMediaQuery("(max-width:1024px)");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const brandColor = useContext(BrandColorContext);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const chainCode = queryParams.get("chainCode");
  const cruiseCode = queryParams.get("cruiseCode");
  const durationID = queryParams.get("durationID");
  const numberRooms = queryParams.get("numberRooms");
  const adultNumber = queryParams.get("adultNumber");
  const childNumber = queryParams.get("childNumber");
  const childAgesParam = queryParams.get("childAges");
  const operationID = queryParams.get("operationID");

  const cbinID = queryParams.get("cbinID");
  const cruiseRateId = queryParams.get("cruiseRateId");
  const extrasIdsParam = queryParams.get("extrasIds");
  const extrasParam = queryParams.get("extras");
  const itineraryId = queryParams.get("itineraryId");
  const operationDate = queryParams.get("operationDate");
  const cruiseId = queryParams.get("cruiseId");
  const numCabins = queryParams.get("numCabins");
  const bookingId = queryParams.get("bookingId");
  const bookingRef = queryParams.get("bookingRef");

  const language = useSelector((state) => state.language.language) || "en";
  const { checkOut, loading: checkoutLoading, error } = useSelector((state) => state.checkOut);
  const { confirmationBooking, loading: confirmationLoading } = useSelector(
    (state) => state.confirmationBooking
  );

  useEffect(() => {
    // This condition ensures the fetch only happens if checkout data is not already in the state
    // which is the case on a page refresh.
    if (!checkOut?.cruiseID) {
      // Reconstruct the cabins array from URL parameters
      const cabins = [];
      const cabinsCount = parseInt(numCabins, 10) || 0;
      for (let i = 1; i <= cabinsCount; i++) {
        const cabinId = parseInt(queryParams.get(`cabinId_room_${i}`), 10);
        const rateTypeId = parseInt(
          queryParams.get(`rateTypeId_room_${i}`),
          10
        );
        const adults = parseInt(queryParams.get(`adults_room_${i}`), 10);
        const children = parseInt(queryParams.get(`children_room_${i}`), 10);
        const childrenAgesParam = queryParams.get(`childAges_room_${i}`);
        const childrenAges =
          childrenAgesParam &&
            childrenAgesParam !== "undefined" &&
            childrenAgesParam !== "null"
            ? childrenAgesParam.split(",").filter(Boolean).map(Number)
            : [];
        cabins.push({ cabinId, rateTypeId, adults, children, childrenAges });
      }

      // Reconstruct the extras array from URL parameters
      const extras = extrasParam ? JSON.parse(extrasParam) : [];

      const bookingPayload = {
        booking: {
          cruiseId: parseInt(cruiseId, 10),
          itineraryId: parseInt(itineraryId, 10),
          operationDate: operationDate,
        },
        cabins: cabins,
        extras: extras,
      };

      dispatch(fetchCheckOut({ payload: bookingPayload, chainCode, language }))
        .unwrap()
        .catch((error) => {
          console.error("Failed to refetch checkout data:", error);
        });
    }
  }, [dispatch, location.search, language]);

  // Map through the nationalities to extract the IDs
  const nationalityData = checkOut?.nationalities;
  const data =
    nationalityData?.map((item, index) => ({
      label: item.nationalityName, // Ensure this property exists
      value: item.nationalityID, // Check if this property exists
    })) || [];

  const [terms, setTerms] = useState(false);
  const validationSchema = useMemo(
    () =>
      Yup.object().shape({
        customerFirstName: Yup.string().required(t("common.firstNameRequired")),
        customerLastName: Yup.string().required(t("common.lastNameRequired")),
        customerEmailAddress: Yup.string()
          .email(t("common.invalidEmail"))
          .required(t("common.emailRequired")),
        customerMobile: Yup.string().required(t("common.phoneNumberRequired")),
        nationalityID: Yup.number().required(t("common.nationalityRequired")),
        special_Requirement: Yup.string(),
        // terms: Yup.bool().oneOf([true], t("common.termsRequired")),
      }),
    [t]
  );

  const [open, setOpen] = React.useState(false);
  const [msg, setMsg] = useState("");

  const handleClick = () => {
    setOpen(true);
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  const handleCheckoutClick = useCallback(
    async (values) => {
      if (checkOut) {
        const payload = {
          booking: {
            cruiseId: parseInt(cruiseId, 10),
            itineraryId: parseInt(itineraryId, 10),
            operationDate: operationDate,
          },
          cabins: checkOut?.cabinsChoices?.map((c) => ({
            cabinId: c.cabinID,
            rateTypeId: c.rateTypeID,
            adults: c.adultsNum,
            children: c.childrenNum,
            childrenAges: c.childrenAges,
          })),
          extras: checkOut?.selectedExtrasDetails?.map((extra) => ({
            extraId: extra.extraId,
            adultQuantity: extra.adultQuantity,
            childQuantity: extra.childQuantity,
          })),
          user: {
            firstName: values.customerFirstName,
            lastName: values.customerLastName,
            phoneNumber: values.customerMobile,
            emailAddress: values.customerEmailAddress,
            nationalityId: values.nationalityID.toString(),
          },
        };
        setOpen(false);
        setMsg("");
        try {
          const resultAction = await dispatch(
            fetchConfirmationBooking({ payload, chainCode, language: "en" })
          );

          if (fetchConfirmationBooking.fulfilled.match(resultAction)) {
            if (resultAction.payload?.success) {
              localStorage.setItem(
                "confirmationNumber",
                resultAction.payload.confirmationNumber
              );
              const kashierUrl = resultAction.payload.redirectURL;
              console.log(kashierUrl);
              if (kashierUrl) {
                console.log("Redirecting to:", kashierUrl);
                window.location = kashierUrl;
              } else {
                alert(t("common.unableToRedirect"));
              }
            } else if (resultAction.payload?.message) {
              setOpen(true);
              setMsg(resultAction.payload.message);
            }
          } else {
            throw new Error(resultAction.error.message);
          }
        } catch (err) {
          alert(err.message || t("common.errorOccurredWhileSearching"));
        }
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      checkOut,
      dispatch,
      confirmationBooking?.redirectURL,
      confirmationBooking?.success,
    ]
  );
  return (
    <Fragment>
      {checkoutLoading ? (
        <Loader />
      ) : error ? (
        <p>{error}</p>
      ) : (
        <>
          {" "}
          <Helmet>
            <title>{t("booking.guestInformationCheckout")}</title>
            <style>
              {`
            .header .header-menu .menu li a{
            color:#051036;
            }
            .header .header-menu .menu .subnav>li>a {
            color:#051036 !important;
            }
            .is-sticky.bg-dark-1{
            background-color:#fff !important;
            }
            // .is-sticky .menu li a{
            // color:#fff !important;
            // }
            .ratio-15\:9::before{
            padding-bottom:0 !important;}
            `}
            </style>
          </Helmet>
          {/*banner */}
          <section className="row d-flex items-center  mt-60  ">
            <div className="  mt-40 py-40 bg-light-2 border-top-light">
              <div className="container d-flex justify-content-between m-auto px-1    y-gap-30 items-center ">
                <div className="col-auto pe-1">
                  <div
                    className="d-flex items-center"
                    // onClick={() => navigate(-3)}
                    onClick={() =>
                      chainCode != "cyanegypt" &&
                      navigate(`/booking-cruises${location.search}`)
                    }
                    style={{
                      cursor: chainCode != "cyanegypt" ? "pointer" : "default",
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.color = brandColor;
                    }}
                  >
                    <div className="size-40 rounded-full flex-center bg-blue-1">
                      <i className="icon-check text-16 text-white"></i>
                    </div>
                    <div className="text-18 text-blue-1 fw-500 ml-10">
                      {t("booking.chooseCruise")}
                    </div>
                  </div>
                </div>{" "}
                <div className="col px-1">
                  <div className="w-full h-1 border-blue-1 bg-border"></div>
                </div>
                <div className="col-auto  px-1">
                  <div
                    className="d-flex items-center"
                    onClick={() =>
                      chainCode != "cyanegypt" &&
                      navigate(`/cruises-details${location.search}`)
                    }
                    style={{
                      cursor: chainCode != "cyanegypt" ? "pointer" : "default",
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.color = brandColor;
                    }}
                  >
                    <div className="size-40 rounded-full flex-center bg-blue-1">
                      <i className="icon-check text-16 text-white"></i>
                    </div>
                    <div className="text-18 text-blue-1 fw-500 ml-10">
                      {t("booking.chooseCabin")}
                    </div>
                  </div>
                </div>
                <div className="col px-1">
                  <div className="w-full h-1 border-blue-1 bg-border"></div>
                </div>
                {checkOut?.isExtrasExists && (
                  <Fragment>
                    <div className="col-auto px-1">
                      <div
                        className="d-flex items-center"
                        onClick={() =>
                          chainCode != "cyanegypt" &&
                          navigate(`/add-extra${location.search}`)
                        }
                        style={{
                          cursor:
                            chainCode != "cyanegypt" ? "pointer" : "default",
                        }}
                        onMouseEnter={(e) => {
                          e.target.style.color = brandColor;
                        }}
                      >
                        <div className="size-40 rounded-full flex-center bg-blue-2">
                          <div className="size-40 rounded-full flex-center bg-blue-1">
                            <i className="icon-check text-16 text-white"></i>
                          </div>
                        </div>
                        <div className="text-18 text-blue-1 fw-500 ml-10">
                          {t("booking.addExtra")}
                        </div>
                      </div>
                    </div>

                    <div className="col px-1">
                      <div className="w-full h-1 border-blue-1 bg-border"></div>
                    </div>
                  </Fragment>
                )}
                <div className="col-auto px-1">
                  <div className="d-flex items-center">
                    <div className="size-40 rounded-full flex-center bg-blue-1">
                      <span className=" text-16 text-white">
                        {checkOut?.isExtrasExists ? "4" : "3"}
                      </span>
                    </div>
                    <div className="text-18 fw-500 ml-10">
                      {t("booking.checkout")}{" "}
                    </div>
                  </div>
                </div>
                <div className="col px-1">
                  <div className="w-full h-1 bg-border"></div>
                </div>
                <div className="col-auto px-1">
                  <div className="d-flex items-center">
                    <div className="size-40 rounded-full flex-center bg-blue-1-05 text-blue-1 fw-500">
                      {checkOut?.isExtrasExists ? "5" : "4"}
                    </div>
                    <div className="text-18 fw-500 ml-10">
                      {t("booking.bookingCompleted")}{" "}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section className="pt-40 layout-pb-md">
            <div className="container">
              <div className="row justify-content-between">
                <div className="col-xl-7 col-lg-8">
                  <h2 className="text-22 fw-500  ">
                    {t("common.yourPersonalInformation")}
                  </h2>

                  <Formik
                    initialValues={{
                      customerFirstName: "",
                      customerLastName: "",
                      customerEmailAddress: "",
                      customerMobile: "",
                      nationalityID: 0,
                      special_Requirement: "",
                    }}
                    validationSchema={validationSchema}
                    onSubmit={(values) => {
                      handleCheckoutClick(values);
                    }}
                  >
                    {(values) => (
                      <Form>
                        <div className="row x-gap-20 y-gap-20 pt-20">
                          <div className="col-md-6">
                            <div className="form-input">
                              <Field
                                name="customerFirstName"
                                type="text"
                                className="form-control"
                                required
                              />
                              <label className="lh-1 text-16 text-light-1">
                                {t("common.firstName")}
                              </label>
                            </div>
                            <ErrorMessage
                              name="customerFirstName"
                              component="div"
                              className="error text-danger text-red-1 d-block text-center"
                            />
                          </div>
                          <div className="col-md-6">
                            <div className="form-input">
                              <Field
                                name="customerLastName"
                                type="text"
                                className="form-control"
                                required
                              />
                              <label className="lh-1 text-16 text-light-1">
                                {t("common.lastName")}
                              </label>
                            </div>
                            <ErrorMessage
                              name="customerLastName"
                              component="div"
                              className="error text-danger text-red-1 d-block text-center"
                            />
                          </div>
                          <div className="col-md-6">
                            <div className="form-input">
                              <Field
                                name="customerEmailAddress"
                                type="text"
                                required
                              />
                              <label className="lh-1 text-16 text-light-1">
                                {t("common.email")}
                              </label>
                            </div>
                            <ErrorMessage
                              name="customerEmailAddress"
                              component="div"
                              className="error text-danger text-red-1 d-block text-center"
                            />
                          </div>
                          <div className="col-md-6">
                            <div className="form-input">
                              <Field
                                name="customerMobile"
                                type="text"
                                required
                              />
                              <label className="lh-1 text-16 text-light-1">
                                {t("common.phoneNumber")}
                              </label>
                            </div>
                            <ErrorMessage
                              name="customerMobile"
                              component="div"
                              className="error text-danger text-red-1 d-block text-center"
                            />
                          </div>
                          <div className="col-md-12">
                            <div className="form-input ">
                              <Field
                                as={SelectPicker}
                                name="nationalityID"
                                data={data} // Ensure data is not empty
                                size="lg"
                                placeholder={t("common.selectNationality")}
                                onChange={(value) => {
                                  values.setFieldValue("nationalityID", value);
                                }}
                              />
                            </div>{" "}
                            <ErrorMessage
                              name="nationalityID"
                              component="div"
                              className="error text-danger text-red-1 d-block text-center"
                            />
                          </div>
                          <div className="col-12">
                            <div className="form-input">
                              <Field
                                name="special_Requirement"
                                as="textarea"
                                rows="6"
                              />
                              <label className="lh-1 text-16 text-light-1">
                                {t("common.specialRequests")}
                              </label>
                            </div>
                          </div>
                        </div>

                        <div className="w-full h-1 bg-border mt-40 mb-40"></div>
                        <div className="col-12">
                          <div className="row y-gap-20 items-center justify-between">
                            {/* <div className="form-checkbox d-flex align-items-center">
                              <Field
                                type="checkbox"
                                checked={terms}
                                value={terms}
                                onChange={(e) => setTerms(e.target.checked)}
                              />
                              <div className="form-checkbox__mark">
                                <div className="form-checkbox__icon icon-check"></div>
                              </div>
                              <div className="col-auto ms-2">
                                <label
                                  htmlFor="terms"
                                  className="text-14 text-light-1"
                                >
                                  By proceeding with this booking, I agree to
                                  Booking Nile 
                                  <Link to="#.">Terms & Conditions</Link>.
                                </label>
                              </div>
                            </div> */}
                            {/* <ErrorMessage
                              name="terms"
                              component="div"
                              className="error text-danger text-red-1 d-block text-center"
                            /> */}
                            <div className="col-auto">
                              <button
                                type="submit"
                                className="button h-60 px-24 -dark-1 bg-blue-1 text-white"
                                disabled={confirmationLoading}
                              >
                                {confirmationLoading ? (
                                  <div className="d-flex items-center">
                                    <div className="spinner-border spinner-border-sm me-2" role="status"></div>
                                    {t("common.loading") || "Loading..."}
                                  </div>
                                ) : (
                                  t("common.bookNow")
                                )}
                              </button>
                            </div>
                          </div>
                        </div>
                      </Form>
                    )}
                  </Formik>
                  <div>
                    <Snackbar
                      open={open}
                      autoHideDuration={10000}
                      onClose={handleClose}
                    >
                      <Alert
                        onClose={handleClose}
                        severity="success"
                        variant="filled"
                        sx={{ width: "100%" }}
                      >
                        {msg}
                      </Alert>
                    </Snackbar>
                  </div>
                </div>

                <div className="col-12 col-lg-4">
                  <div className="">
                    {/* Extras  */}

                    <div className="px-30 py-30 mt-20 border-light rounded-4">
                      <div className="row align-items-center x-gap-15 y-gap-20">
                        <div className="text-20 fw-500  mb-20">
                          {t("common.yourBookingDetails")}{" "}
                        </div>
                        <div className="col-auto">
                          <img
                            src={checkOut?.cruisePhoto}
                            alt={checkOut?.cruiseName}
                            style={{ borderRadius: "10px" }}
                            loading="lazy"
                            className="size-120   object-cover"
                          />
                        </div>

                        <div className="col">
                          <div className="text-20 lh-17 fw-500">
                            {checkOut?.cruiseName}{" "}
                          </div>
                          <div
                            className="d-flex x-gap-5 pb-10"
                            dangerouslySetInnerHTML={{
                              __html: checkOut?.ratingStarCode,
                            }}
                          />

                          <div className="text-14 lh-15 mt-5  ">
                            <FontAwesomeIcon icon={faMapLocationDot} />{" "}
                            <span className="text-secondary">
                              {checkOut?.durationName}{" "}
                            </span>
                          </div>
                        </div>
                      </div>

                      <div className="border-top-light mt-30 mb-20"></div>

                      <div className="row y-gap-20 justify-between">
                        <div className="col-auto">
                          <div className="text-15">{t("common.checkIn")} </div>
                          <div className="fw-500">{checkOut?.checkInDate}</div>
                        </div>

                        <div className="col-auto md:d-none">
                          <div className="h-full w-1 bg-border"></div>
                        </div>

                        <div className="col-auto text-right md:text-left">
                          <div className="text-15">{t("common.checkOut")} </div>
                          <div className="fw-500">{checkOut?.checkOutDate}</div>
                        </div>
                      </div>
                      <div className="border-top-light mt-30 mb-20"></div>

                      <h5 className="text-15 mb-20">
                        {t("common.youSelected")}{" "}
                      </h5>
                      {checkOut?.cabinsChoices?.map((cabin, index) => (
                        <div
                          className="row y-gap-20 justify-between items-center"
                          key={cabin.cabinID}
                        >
                          <div className="col-auto d-flex">
                            <img
                              style={{ borderRadius: "5px" }}
                              src={cabin.cabinPhoto}
                              alt=""
                              className="me-2"
                              width="50"
                            />{" "}
                            <div className="text-main fw-500 text-16">
                              {cabin.cabinName}
                              <br />
                              <span className="text-12 text-secondary">
                                {" "}
                                (
                                {cabin.rateTypeName ||
                                  t("common.missedRateTypeName")}
                                )
                              </span>
                            </div>
                          </div>

                          <div className="col-auto d-flex flex-column align-items-end justify-content-start">
                            <div className="col-auto d-flex align-items-center">
                              <div className="text-12 text-secondary">
                                (
                                {cabin.cabinBedType || t("common.cabinBedType")}
                                ){" "}
                              </div>

                              <FontAwesomeIcon
                                icon={faBed}
                                className="text-12 text-main ps-1"
                              />
                            </div>
                            <div className="col-auto  d-flex align-items-center">
                              <div className="text-12 text-secondary">
                                (
                                {`${cabin.adultsNum} ${cabin.adultsNum > 1
                                    ? t("common.adults")
                                    : t("common.adults").slice(0, -1)
                                  }`}
                                {`${cabin.childrenNum > 0
                                    ? ` & ${cabin.childrenNum} ${cabin.childrenNum > 1
                                      ? t("common.children")
                                      : t("common.children").slice(0, -1)
                                    }`
                                    : ""
                                  }`}
                                )
                              </div>
                              <FontAwesomeIcon
                                icon={faUsersViewfinder}
                                className="text-12 text-main ps-1"
                              />
                            </div>
                            <div className="col-auto  d-flex align-items-center">
                              <div className="text-12 text-secondary">
                                ({cabin.cabinSize || t("common.cabinSize")}){" "}
                              </div>
                              <FontAwesomeIcon
                                icon={faMaximize}
                                className="text-12 text-main ps-1"
                              />
                            </div>
                          </div>
                          {index < checkOut?.cabinsChoices?.length - 1 && (
                            <div className="border-top-light my-1"></div>
                          )}
                        </div>
                      ))}

                      {checkOut?.selectedExtrasDetails?.length > 0 ? (
                        <Fragment>
                          <div className="border-top-light mt-30 mb-20"></div>
                          <div className="row y-gap-20 justify-between items-center">
                            <h5 className="text-15">{t("booking.extras")}: </h5>
                            <ul className="ps-0">
                              {checkOut?.selectedExtrasDetails?.map(
                                (extra, index) => (
                                  <li
                                    key={extra.extraId}
                                    className={`row d-flex justify-content-between align-items-center py-2 ps-1  `}
                                  >
                                    <p className="d-flex align-items-center me-2 col-lg-8">
                                      <img
                                        src={extra.extraPhoto}
                                        width={60}
                                        height={60}
                                        alt={extra.extraName}
                                        className="rounded-full px-1"
                                      />

                                      <h6 className="form-select  text-14 text-main fw-400">
                                        {extra.extraName} <br />{" "}
                                        <span className="text-12 text-secondary">
                                          ({extra.adultQuantity}{" "}
                                          {extra.adultQuantity > 1
                                            ? t("common.adults")
                                            : t("common.adults").slice(
                                              0,
                                              -1
                                            )}{" "}
                                          & {extra.childQuantity}{" "}
                                          {extra.childQuantity > 1
                                            ? t("common.children")
                                            : t("common.children").slice(0, -1)}
                                          )
                                        </span>
                                      </h6>
                                    </p>
                                    <p className="me-2 fw-bold col-lg-3 text-center  text-primary">
                                      {checkOut.currencyCode}
                                      {extra.totalPrice}
                                    </p>
                                  </li>
                                )
                              )}
                            </ul>
                            <div className="col-auto mx-auto py-0">
                              <div className="text-14">
                                {checkOut?.selectedExtrasDetails?.length}{" "}
                                {checkOut?.selectedExtrasDetails?.length > 1
                                  ? t("common.extras")
                                  : t("common.extra")}{" "}
                                , ({checkOut.currencyCode}
                                {checkOut?.totalExtras})
                              </div>
                            </div>
                            <button
                              type="button"
                              onClick={() =>
                                navigate(`/add-extra${location.search}`)
                              }
                              className="text-15 text-blue-1 underline"
                            >
                              {t("booking.changeYourExtraSelection")}{" "}
                            </button>
                          </div>
                        </Fragment>
                      ) : null}
                    </div>
                    {/* <div className="px-30 py-30 border-light rounded-4 mt-30">
                      <div className="text-20 fw-500 mb-15">
                        Do you have a promo code?{" "}
                      </div>

                      <div className="form-input ">
                        <input type="text" required="" />
                        <label className="lh-1 text-16 text-light-1">
                          Enter promo code{" "}
                        </label>
                      </div>

                      <button className="button -outline-blue-1 text-blue-1 px-30 py-15 mt-20">
                        Apply{" "}
                      </button>
                    </div> */}
                    <div className="px-30 py-30 border-light rounded-4 mt-30">
                      <div className="text-20 fw-500 mb-20">
                        {t("booking.yourPriceSummary")}{" "}
                      </div>
                      <div className="row y-gap-5 justify-between">
                        <div className="col-auto">
                          <div className="text-15">{t("booking.cabins")}</div>
                        </div>
                        <div className="col-auto">
                          <div className="text-15">
                            {" "}
                            {checkOut?.currencyCode}
                            {checkOut?.totalCabins}{" "}
                          </div>
                        </div>
                      </div>
                      <div className="row y-gap-5 justify-between">
                        <div className="col-auto">
                          <div className="text-15">{t("booking.extras")}</div>
                        </div>
                        <div className="col-auto">
                          <div className="text-15">
                            {" "}
                            {checkOut?.currencyCode}
                            {checkOut?.totalExtras}{" "}
                          </div>
                        </div>
                      </div>
                      {checkOut?.taxesDetails?.map((item, index) => (
                        <div
                          key={index}
                          className="row y-gap-5 justify-between"
                        >
                          <div className="col-auto">
                            <div className="text-15">{item.taxName} </div>
                          </div>
                          <div className="col-auto">
                            <div className="text-15">
                              {" "}
                              {checkOut?.currencyCode}
                              {item?.taxAmount?.toFixed(2)}{" "}
                            </div>
                          </div>
                        </div>
                      ))}

                      <div className="px-20 py-20 bg-blue-2 rounded-4 mt-20">
                        <div className="row y-gap-5 justify-between">
                          <div className="col-auto">
                            <div className="text-18 lh-13 fw-500">
                              {t("common.totalPrice")}{" "}
                            </div>
                          </div>
                          <div className="col-auto">
                            <div className="text-18 lh-13 fw-500">
                              {checkOut?.currencyCode}
                              {checkOut?.grandTotal?.toFixed(2)}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>{" "}
                </div>
              </div>
            </div>
          </section>
        </>
      )}{" "}
    </Fragment>
  );
};

export default Checkout;
